var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({class:[
    'd-inline-flex',
    'btn',
    ("btn-" + _vm.theme),
    {
      'btn-sm': _vm.size === 'sm',
      'btn-lg': _vm.size === 'lg',
      'btn-icon-only': _vm.isIconOnly,
      'btn-with-icon': _vm.isIconLeft || _vm.isIconCenter || _vm.isIconRight,
      'is-loading': _vm.isLoading,
    }
  ],attrs:{"type":_vm.buttonType,"disabled":_vm.disabled}},_vm.$listeners),[(_vm.isIconOnly)?[_c('m-icon',{attrs:{"variant":_vm.iconVariant}})]:[(_vm.isIconLeft)?_c('m-icon',{staticClass:"ml-n2 is-left align-self-center",attrs:{"variant":_vm.iconVariant}}):_vm._e(),(_vm.isIconCenter)?_c('m-icon',{attrs:{"variant":_vm.iconVariant}}):_vm._e(),_vm._t("default",[_c('span',{class:[
        'align-self-center',
        {
          'mr-n1': _vm.isIconLeft,
          'ml-n1': _vm.isIconRight,
        }
      ]},[_vm._v(_vm._s(_vm.convertedLabel))])]),(_vm.isIconRight)?_c('m-icon',{staticClass:"mr-n2 is-right align-self-center",attrs:{"variant":_vm.iconVariant}}):_vm._e()]],2)}
var staticRenderFns = []

export { render, staticRenderFns }